import { getDefaultLocale } from '@makyoapp/makyo-common'

export function IPadProHead({ style, fill = 'black' }: { style?: React.CSSProperties; fill?: string }) {
  return (
    <div className='w-full flex justify-between items-center px-2 h-[50px]' style={style}>
      <IPadClock fill={fill} />
      <IPadStatusIcons fill={fill} />
    </div>
  )
}

export const IPadClock = ({ fill = 'black' }) => {
  const date = new Date()
  const clockText = date.toLocaleTimeString(getDefaultLocale(), {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  })

  return (
    <svg width='100' height='50' viewBox='0 0 100 50' className='flex-none'>
      <text
        fontFamily='-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif'
        fontSize='16px'
        fontWeight='600'
        x='20'
        y='36'
        fill={fill}
      >
        {clockText}
      </text>
    </svg>
  )
}

export const IPadStatusIcons = ({ fill = 'black' }) => {
  return (
    <svg width='120' height='50' viewBox='0 0 120 50' className='flex-none'>
      {/* Cellular Signal */}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.824 23.6514H19.647C18.997 23.6514 18.471 24.1521 18.471 24.7697V34.4621C18.471 35.0798 18.997 35.5805 19.647 35.5805H20.824C21.473 35.5805 22 35.0798 22 34.4621V24.7697C22 24.1521 21.473 23.6514 20.824 23.6514ZM14.157 26.2617H15.334C15.984 26.2617 16.51 26.7624 16.51 27.3801V34.463C16.51 35.0806 15.984 35.5813 15.334 35.5813H14.157C13.508 35.5813 12.981 35.0806 12.981 34.463V27.3801C12.981 26.7624 13.508 26.2617 14.157 26.2617ZM9.843 28.8706H8.667C8.017 28.8706 7.49 29.3713 7.49 29.989V34.4624C7.49 35.08 8.017 35.5807 8.667 35.5807H9.843C10.493 35.5807 11.02 35.08 11.02 34.4624V29.989C11.02 29.3713 10.493 28.8706 9.843 28.8706ZM4.353 31.1074H3.176C2.527 31.1074 2 31.6081 2 32.2258V34.4625C2 35.0801 2.527 35.5808 3.176 35.5808H4.353C5.003 35.5808 5.529 35.0801 5.529 34.4625V32.2258C5.529 31.6081 5.003 31.1074 4.353 31.1074Z'
        fill={fill}
      />

      {/* WiFi Icon */}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M47.229 25.4615C49.748 25.4617 52.17 26.4293 53.995 28.1644C54.132 28.2984 54.352 28.2967 54.487 28.1607L55.801 26.8348C55.869 26.7658 55.908 26.6723 55.907 26.575C55.907 26.4778 55.867 26.3848 55.798 26.3165C51.008 21.7257 43.45 21.7257 38.66 26.3165C38.591 26.3847 38.551 26.4777 38.551 26.575C38.55 26.6722 38.588 26.7657 38.657 26.8348L39.971 28.1607C40.106 28.2969 40.326 28.2986 40.463 28.1644C42.288 26.4292 44.711 25.4615 47.229 25.4615ZM47.229 29.7748C48.613 29.7747 49.947 30.289 50.973 31.2178C51.111 31.3496 51.33 31.3467 51.465 31.2113L52.777 29.8854C52.846 29.8159 52.885 29.7215 52.884 29.6235C52.883 29.5255 52.842 29.4319 52.772 29.3638C49.649 26.4585 44.812 26.4585 41.689 29.3638C41.618 29.4319 41.578 29.5255 41.577 29.6236C41.576 29.7217 41.615 29.816 41.684 29.8854L42.996 31.2113C43.131 31.3467 43.349 31.3496 43.488 31.2178C44.513 30.2896 45.846 29.7754 47.229 29.7748ZM49.857 32.6773C49.859 32.7756 49.821 32.8704 49.751 32.9393L47.481 35.23C47.414 35.2973 47.323 35.3352 47.229 35.3352C47.134 35.3352 47.043 35.2973 46.977 35.23L44.707 32.9393C44.636 32.8703 44.598 32.7755 44.6 32.6772C44.602 32.5789 44.645 32.4858 44.718 32.4199C46.167 31.1938 48.29 31.1938 49.74 32.4199C49.813 32.4858 49.855 32.579 49.857 32.6773Z'
        fill={fill}
      />

      {/* Battery Icon */}
      <path
        opacity='0.4'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77.5 23.6514H93.501C95.434 23.6514 97.001 25.2184 97.001 27.1514V31.1514C97.001 33.0844 95.434 34.6514 93.501 34.6514H77.5C75.567 34.6514 74 33.0844 74 31.1514V27.1514C74 25.2184 75.567 23.6514 77.5 23.6514ZM73 27.1514C73 24.6661 75.015 22.6514 77.5 22.6514H93.501C95.987 22.6514 98.001 24.6661 98.001 27.1514V31.1514C98.001 33.6366 95.987 35.6514 93.501 35.6514H77.5C75.015 35.6514 73 33.6366 73 31.1514V27.1514ZM100.517 29.1985C100.517 30.2074 99.913 31.1179 98.983 31.5094V26.8877C99.913 27.2791 100.517 28.1897 100.517 29.1985Z'
        fill={fill}
      />
      <path
        d='M75 27.1514C75 25.7707 76.119 24.6514 77.5 24.6514H93.501C94.882 24.6514 96.001 25.7707 96.001 27.1514V31.1514C96.001 32.5321 94.882 33.6514 93.501 33.6514H77.5C76.119 33.6514 75 32.5321 75 31.1514V27.1514Z'
        fill={fill}
      />
    </svg>
  )
}
